// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"304":"f30b9b4a","930":"96eb919e"}[chunkId] + ".chunk.css";
};